import type { SequenceState } from '../state';

export const setSearchUnsequencedAdsTerm = (state: SequenceState, searchTerm: string): SequenceState => {
  return {
    ...state,
    searchUnsequencedAdsTerm: searchTerm,
  };
};
